
import AddProductPage from "./add-product/AddProductPage";

const AddProduct = () => <AddProductPage />;

export default AddProduct;
